'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _clone = require('clone');

var _clone2 = _interopRequireDefault(_clone);

var _properties = require('../properties');

var properties = _interopRequireWildcard(_properties);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (styles, props, arr) {
	var obj = (0, _clone2.default)(styles);

	arr.forEach(function (x) {
		obj = Object.assign(obj, properties[x.toLowerCase()].styles(styles, props));
	});

	return obj;
};